import { Dispatch, SetStateAction, useEffect } from 'react';

import { useAlert } from '@/hooks/useAlert';
import { useConfirm } from '@/hooks/useConfirm';
import useInvalidateFromMutation from '@/queries/useInvalidateFromMutation';
import { QueryKeyFunctionType } from '@/types/Queries.types';

export default function useFakerOn<T>(
	queryKeyFunction: QueryKeyFunctionType,
	selectData: T[],
	setSelectData: Dispatch<SetStateAction<T[]>>,
	setClearRows: Dispatch<SetStateAction<boolean>>,
) {
	const { alertMessage } = useAlert();
	const { confirmMessage } = useConfirm();

	const tcsNoList = selectData.map((data: any) => {
		if (data && typeof data === 'object' && 'tcs_no' in data) return data['tcs_no'];
	});

	const fakerOn = useInvalidateFromMutation(queryKeyFunction, 'fakerOn', tcsNoList);

	const fakerOnMutate = async () => {
		console.log(tcsNoList);
		if (tcsNoList.length < 1) {
			alertMessage(`FAKER를 가동 시키실 비상벨을 선택해주세요.`);
			return false;
		}

		if (await confirmMessage(`선택하신 비상벨의 FAKER를 가동 시키시겠습니까?`)) {
			fakerOn.mutate();
		} else {
			setSelectData([]);
			setClearRows((prev) => !prev);
		}
	};

	useEffect(() => {
		if (fakerOn.isSuccess) {
			setSelectData([]);
			setClearRows((prev) => !prev);
		}
	}, [fakerOn.isSuccess, setSelectData, setClearRows]);

	return () => {
		return (
			<button type="button" className="btn btn-green" onClick={fakerOnMutate}>
				FAKER 가동
			</button>
		);
	};
}
